import * as React from 'react';

export const IconLabel: React.FC<{ icon: string; children?: React.ReactNode }> = ({ icon, children }) => (
    <div className="list-centered-icon">
        <i className="material-icons list-icon">{icon}</i>
        <span>{children}</span>
    </div>
);
